import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {getEnvVariables} from "helpers/getEnvVariables";

const {REACT_APP_URL} = getEnvVariables();

export const nuveiApi = createApi({
  reducerPath: "nuvei",
  baseQuery: fetchBaseQuery({
    baseUrl: REACT_APP_URL,
    responseHandler: async (response) => {
      const data = await response.json();
      return {
        ...data,
        meta: {
          status: response.status,
        },
      };
    },
  }),
  endpoints: (builder) => ({
    getCards: builder.query({
      query: () => ({
        url: "api/v2/all/credit-card",
        headers: {
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        },
      }),
    }),
    saveCard: builder.mutation({
      query: (body) => ({
        url: "api/v2/add/credit-card",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        },
        body,
      }),
    }),
    debitWithToken: builder.mutation({
      query: (body) => ({
        url: "api/v2/debit/credit-card",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        },
        body,
      }),
    }),
    deleteCard: builder.mutation({
      query: ({userId, tokenCard}) => ({
        url: `api/v2/delete/credit-card`,
        method: "DELETE",
        body: {userId, tokenCard},
        headers: {
          "Content-Type": "application/json",
          Authorization: JSON.parse(localStorage.getItem("user")!)?.token,
        },
      }),
    }),
  }),
});

export const {
  useGetCardsQuery,
  useSaveCardMutation,
  useDebitWithTokenMutation,
  useDeleteCardMutation,
} = nuveiApi;
